export enum UserFlag {
  ENABLE_AGENCY_PARTNER_STACK = 'enable_agency_partner_stack',
  ENABLE_MOBILE_BANNER_EXPERIMENT_SEQUEL = 'enable_mobile_banner_experiment_sequel',
  MANDATORY_EMAIL_VERIFICATION = 'mandatory_email_verification',
  ENABLE_APP_INTERCOM_REMOVE = 'enable_app_intercom_remove',
  ENABLE_AI_INTERVIEWS_GENERAL = 'enable_ai_interviews_general',
  ENABLE_AI_INTERVIEWS_HOME_TAB = 'enable_ai_interviews_home_tab',
  SHOW_IG_SUMMIT_SPEAKERS_BANNER = 'show_ig_summit_speakers_banner',
  ENABLE_FIN_AI_EXPERIMENT = 'enable_fin_ai_experiment',
  DISABLE_BRAZE_NOTIFICATIONS_FOR_WEB_VIEW = 'disable_braze_notifications_for_web_view',
}

export enum AccountFlag {
  WA_MM_LITE = 'wa_mm_lite',
  ENABLE_FACELIFTING_FOR_CONFERENCE = 'enable_facelifting_for_conference',
  ENABLE_IG_RECURRING_NOTIFICATION = 'enable_ig_recurring_notification',
  ENABLE_INBOX = 'enable_inbox',
  ENABLE_INDIAN_CUSTOMERS_3DS_RESUBSCRIPTION = 'enable_indian_customers_3ds_resubscription',
  ENABLE_LC_STATISTICS = 'enable_lc_statistics',
  ENABLE_WEBVIEW = 'enable_webview',
  FETCH_STORIES_FROM_CDN = 'fetch_stories_from_cdn',
  UKRAINE_2022_SUPPORT = 'ukraine_2022_support',
  UKRAINE_2022_SUPPORT_SHOW_MODAL = 'ukraine_2022_support_show_modal',
  WA_CLOUD_API_RECONNECT_ALLOWED = 'wa_cloud_api_reconnect_allowed',
  ENABLE_DM_LIST_IMPROVEMENTS = 'enable_dm_list_improvements',
  ENABLE_IG_CROSS_CHANNEL_BUTTON = 'enable_ig_cross_channel_button',
  ENABLE_WA_CATALOG = 'enable_wa_catalog',
  NOT_CHECKED_FOR_IMPORT_UNIFIED_SUBSCRIBERS = 'not_checked_for_import_unified_subscribers',
  ENABLE_GOOGLE_SHEETS_ACTION_CONFIG_FALLBACK = 'google_sheets_action_config_fallback',
  ENABLE_HIGHLIGHT_INSTRUMENT = 'enable_highlight_instrument',
  UPGRADE_PAGE_GROUP_A = 'upgrade_bb_a',
  UPGRADE_PAGE_GROUP_B = 'upgrade_bb_b',
  TIER_NOTIFICATION_ENABLE = 'enable_90_tier_notification',
  TIER_NOTIFICATION_DISABLE = 'disable_90_tier_notification',
  ENABLE_EASY_BUILDER_6VS3 = 'enable_easy_builder_6_vs_3',
  ENABLE_AI_BUSINESS_CONTEXT = 'enable_ai_business_context',
  ENABLE_HIGHLIGHT_FOR_TIKTOK = 'enable_highlight_for_tiktok',
  ENABLE_AI_PAYWALL = 'enable_ai_paywall',
  ENABLE_CTA_IG_REG_FLOW_EXPERIMENT = 'enable_cta_ig_reg_flow_experiment',
  DISABLE_CTA_IG_REG_FLOW_EXPERIMENT = 'disable_cta_ig_reg_flow_experiment',
  ENABLE_TIKTOK_ADS_TRIGGER = 'enable_tiktok_ads_trigger',
  ENABLE_IN_APP_CARD_ATTACHMENT = 'enable_in_app_card_attachment',
  DISABLE_IN_APP_CARD_ATTACHMENT = 'disable_in_app_card_attachment',
  ENABLE_AI_STEP_STATS = 'enable_ai_step_content_stat_display',
  ENABLE_WA_COEXISTENCE_CONTACTS_IMPORT = 'enable_wa_coexistence_contacts_import',
  ENABLE_BILLING_ADDRESS_ONLY_US = 'enable_billing_address_only_us',
  DISABLE_BILLING_ADDRESS_ONLY_US = 'disable_billing_address_only_us',
  ENABLE_AI_ALWAYS_ON_AUTOMATION = 'enable_ai_always_on_automation',
  ENABLE_AI_FLOW_BETA_TESTER_RECRUITMENT = 'enable_ai_flow_beta_tester_recruitment',
  ENABLE_IN_APP_CHECKOUT_BRAZIL = 'in_app_checkout_brazil',
  ENABLE_IN_APP_CHECKOUT_BRAZIL_REGFLOW = 'in_app_checkout_brazil_regflow',
  ENABLE_NEW_HOMETAB_INSIGHTS = 'enable_new_hometab_insights',
  ENABLE_GROW_FOLLOWERS_RECOMMEND = 'enable_grow_followers_recommend',
  ENABLE_CHANGE_NAME_USER_ABILITY = 'enable_change_name_user_ability',
  ENABLE_EASY_BUILDER_RECOMMENDATIONS = 'enable_easy_builder_recommendations',
  ENABLE_IMMEDIATELY_CHARGE_AFTER_IMPORT = 'enable_immediately_charge_after_import',
  ENABLE_TIKTOK_REF_LINKS = 'enable_tiktok_ref_links',
  ENABLE_BRAZE_PUSH_NOTIFICATIONS = 'enable_braze_push_notifications',
  ENABLE_WA_PRICING_UPDATE = 'enable_whatsapp_per_message_pricing_model',
  ENABLE_NEW_START_FROM_SCRATCH = 'enable_new_start_from_scratch',
  ENABLE_AI_ALWAYS_ON_AUTOMATION_FEED_COMMENT = 'enable_ai_always_on_automation_feed_comment',
}
